import { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';

// Import pages
import Dashboard from '../pages/dashboard/page';
import Products from '../pages/products/page';
import Orders from '../pages/orders/page';
import Partners from '../pages/partners/page';
import Reports from '../pages/reports/page';
import Users from '../pages/users/page';
import Admin from '../pages/admin/page';
import Inventory from '../pages/inventory/page';
import Home from '../pages/home/page';
import Login from '../pages/login/page';
import Register from '../pages/register/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    )
  },
  {
    path: '/products',
    element: (
      <ProtectedRoute>
        <Products />
      </ProtectedRoute>
    )
  },
  {
    path: '/inventory',
    element: (
      <ProtectedRoute requiredRole="manager">
        <Inventory />
      </ProtectedRoute>
    )
  },
  {
    path: '/orders',
    element: (
      <ProtectedRoute>
        <Orders />
      </ProtectedRoute>
    )
  },
  {
    path: '/partners',
    element: (
      <ProtectedRoute>
        <Partners />
      </ProtectedRoute>
    )
  },
  {
    path: '/reports',
    element: (
      <ProtectedRoute>
        <Reports />
      </ProtectedRoute>
    )
  },
  {
    path: '/users',
    element: (
      <ProtectedRoute requiredRole="manager">
        <Users />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute requiredRole="manager">
        <Admin />
      </ProtectedRoute>
    )
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
